export default {
  onlineAnalysis_00001: "On-line rate analysis of station equipment",
  onlineAnalysis_00002: "Report the time",
  onlineAnalysis_00003: "to",
  onlineAnalysis_00004: "Analysis",
  onlineAnalysis_00005: "Terminal equipment",
  onlineAnalysis_00006: "Online rate =1- Offline duration during the query period/query duration",
  onlineAnalysis_00007: "Device name",
  onlineAnalysis_00008: "Charger model",
  onlineAnalysis_00009: "Charger serial number",
  onlineAnalysis_000010: "Online rate",
  onlineAnalysis_000011: "operation",
  onlineAnalysis_000012: "details",
  onlineAnalysis_000013: "log",
}